module.exports = __webpack_public_path__ + "img/1.90bf0407.svg";